import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import { SIDEBAR_COLLAPSED_WIDTH } from "src/frontend/components/Shared/NavSidebar/sidebarConstants"

export const Badge = styled.div`
  display: inline-block;
  background: ${colors.accentTurquoise};
  color: ${colors.white};

  &.error {
    background: ${colors.error};
    border: 1px solid ${colors.errorText};
    color: ${colors.errorText};
  }

  font-size: 12px;
  font-weight: ${fonts.weight.heavy};
  padding: 4px 8px;
  border-radius: 6px;
  margin: -4px -6px;

  transition: all 150ms ease-out;
  @container sidebar (max-width: ${SIDEBAR_COLLAPSED_WIDTH}px) {
    position: absolute;
    left: 30px;
    bottom: 2px;
    font-size: 8px;
    padding: 2px 6px;
  }
`
